<section (click)="onClickOverlay()" [class.open]="display"
    class="fixed z-10 inset-0 overflow-y-auto"    
    aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center place-content-center justify-center min-h-screen  text-center sm:block">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>



        <div (click)="$event.stopPropagation()"
            class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all  sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div >
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</section>
